export default __webpack_public_path__ + "static/media/reject_white.4111ee57.png";